<template>
  <div class="relative dropdown">
    <div
      class="cursor-pointer"
      @click="toggleDropdown"
    >
      <slot name="trigger" />
    </div>
    <div
      v-show="isDropdownOpen"
      class="absolute z-50 right-0 mt-3 min-w-72 rounded-2xl border border-gray-200 bg-white shadow-xl"
    >
      <slot name="content" />
    </div>
  </div>
</template>


<script lang="ts">
import {defineComponent, onMounted, onUnmounted, ref} from 'vue';

export default defineComponent({
  name: 'Dropdown',
  setup() {
    const isDropdownOpen = ref(false);

    const toggleDropdown = (event: MouseEvent) => {
      event.stopPropagation();
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const closeDropdown = () => {
      isDropdownOpen.value = false;
    };

    const checkClickOutside = (event: MouseEvent) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        closeDropdown();
      }
    };

    onMounted(() => {
      document.addEventListener('click', checkClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener('click', checkClickOutside);
    });

    return {isDropdownOpen, toggleDropdown, closeDropdown};
  },
});
</script>
